import { render, staticRenderFns } from "./exam_details.vue?vue&type=template&id=3de4d316&"
import script from "./exam_details.vue?vue&type=script&lang=js&"
export * from "./exam_details.vue?vue&type=script&lang=js&"
import style0 from "./exam_details.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports